import React from 'react';

export default function RecommendationsPanel({ data }) {
  if (!data) {
    return <div className="recommendations"><p>No data available</p></div>;
  }

  const recommendations = Array.isArray(data?.recommendations) ? data.recommendations : [];

  return (
    <div className="recommendations">
      <h3>💡 Optimization Recommendations</h3>
      {recommendations.length > 0 ? (
        <div className="recommendations-list">
          {recommendations.map((rec, idx) => (
            <div key={idx} className="recommendation-item">
              <div className="rec-number">{idx + 1}</div>
              <div className="rec-content">
                <h4>{rec.title}</h4>
                <p>{rec.description}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No recommendations available</p>
      )}
    </div>
  );
}
